import { useContext } from 'react';
import { DashboardContext } from '../contexts/DashboardContext';
import AnalyticsRangeSelector from './AnalyticsRangeSelector';

interface Props {
  size?: 'x-small' | 'small' | 'normal' | 'large' | 'x-large';
  disabled?: boolean;
  variant?: 'textfield' | 'text';
}

export default function DashboardAnalyticsRangeSelector({
  size = 'normal',
  disabled,
}: Props) {
  const { analyticsRange, setAnalyticsRange } = useContext(DashboardContext);

  return (
    <AnalyticsRangeSelector
      disabled={disabled}
      size={size}
      analyticsRange={analyticsRange}
      setAnalyticsRange={setAnalyticsRange}
    />
  );
}
